const listeners = {};

function validateListener(listener) {
  if (typeof listener !== 'function') {
    throw new Error('listener must be a function');
  }
}

/**
 * A very simple and generic event emitter
 */
const EventEmitter = {
  /**
   * Add a listener for a particular type of event
   *
   * @param {string} type Event type to listen to
   * @param {Function} listener A function to be fired when the event is emitted
   * @return {void}
   */
  on(type, listener) {
    validateListener(listener);

    const callbacks = listeners[type];

    if (callbacks) {
      callbacks.push(listener);
    } else {
      listeners[type] = [listener];
    }
  },

  /**
   * Emit an event of a particular type
   *
   * @param {string} type Type of event to emit
   * @param {...*} args Arguments to pass to the event handler
   * @return {void}
   */
  emit(type, ...args) {
    const callbacks = listeners[type];

    if (callbacks) {
      callbacks.forEach(cb => {
        cb(...args);
      });
    }
  }
};

export default EventEmitter;



// WEBPACK FOOTER //
// ./src/utils/EventEmitter.js